if (!customElements.get('quiz-wrapper')) {
  customElements.define(
    'quiz-wrapper',
    class QuizWrapper extends HTMLElement {
      connectedCallback() {
        this.sliderContainer = this.querySelector('.quizSliderWrapper');
        this.initSlider();
      }

      initSlider() {
        this.slider = new Swiper(".quizSliderWrapper", {
          effect: "cards",
          grabCursor: false,
          allowTouchMove: false, // Prevents manual swiping
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          on: {
            init: () => {
              this.attachRadioListeners();
            },
            slideChange: () => {
              this.attachRadioListeners(); // Re-attach listeners on slide change
              this.updateNextButton();
            },
          },
        });

        // Handle next button clicks
        this.sliderContainer.addEventListener('click', this.handleNextClick.bind(this));
        this.sliderContainer.addEventListener('touchend', this.handleNextClick.bind(this));
      }

      attachRadioListeners() {
        const currentSlide = this.slider.slides[this.slider.activeIndex];
        const radios = currentSlide.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
          // Remove existing listeners to avoid duplicates (optional, if needed)
          radio.removeEventListener('change', this.handleRadioChange.bind(this));
          radio.removeEventListener('touchend', this.handleRadioTouch.bind(this));

          // Attach new listeners
          radio.addEventListener('change', this.handleRadioChange.bind(this));
          radio.addEventListener('touchend', this.handleRadioTouch.bind(this));
        });
      }

      handleRadioChange(evt) {
        this.updateNextButton();
      }

      handleRadioTouch(evt) {
        // Manually trigger the radio selection on touchend for iOS
        const radio = evt.target;
        radio.checked = true; // Force the radio to be checked
        this.handleRadioChange(evt); // Update the UI
      }

      updateNextButton() {
        const currentSlide = this.slider.slides[this.slider.activeIndex];
        const selectedValue = currentSlide.querySelector('input:checked');
        const nextButton = currentSlide.querySelector('.next-button');
        if (nextButton) {
          nextButton.disabled = !selectedValue; // Enable only if a radio is selected
        }
      }

      handleNextClick(evt) {
        if (evt.target.classList.contains('next-button')) {
          this.slider.slideNext();
        }
      }
    }
  );
}